import styles from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';
import classnamesBind from 'classnames/bind';
import { observer } from 'mobx-react-lite';
import { getDensityModeString } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/getMessageListTextStyle';
import * as React from 'react';

const classNames = classnamesBind.bind(styles);

export interface MailListItemUnreadCountProps {
    unreadCount: number;
}

export default observer(function MailListItemUnreadCount(
    props: MailListItemUnreadCountProps
): JSX.Element | null {
    const { unreadCount } = props;

    const unreadCountClasses = classNames(
        styles.unreadCount,
        styles.flex00Auto,
        isFeatureEnabled('mon-densities') &&
            getMessageListTextStyle('Major', getDensityModeString())
    );

    return unreadCount > 1 ? <span className={unreadCountClasses}>({unreadCount})</span> : null;
});
